Apt.fn.make('account.profile.preview', {
	/**
	 * Initialize module
	 */
	init() {
		const scope = this;

		LS.util.load([
			'profile',
			'profile-render'
		], () => {
			LS.api.get('me/profile/' + $.context('id') + '/preview', {
				auth: true,
				namespace: 'profile.preview',
				success: data => {
					document.title = data.name + ' - LandSearch';

					data.listings = data.listing_count > 0;

					scope.$private.render(data);
				}
			});
		});
	},

	/**
	 * Unload module
	 */
	unload() {
		LS.util.reset('profile.preview');

		Apt.profile.unload();
	}
}, {
	/**
	 * Render preview
	 *
	 * @param {Object} data
	 */
	render(data) {
		const views = [
			'_services',
			'entry'
		];

		let pending = views.length

		views.forEach(view => {
			LS.util.view('profile', view, template => {
				pending--;

				$.view.addView('profile.' + view, template);

				if (! pending) {
					LS.profile.transform(data);

					$$('preview').html(
						$.view.render('profile.entry', data)
					)
						.removeClass('g-loading');

					$.set('context', LS.profile.context(data));

					Apt.profile.init();
				}
			});
		});
	}
});